//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../../../media/MediaQuery";

//css
import styled from "styled-components";
import { M } from "../../../../utils/MT";

// component
import BasicBtn from "../../../../component/button/BasicBtn";
import RadioBox from "../../../../component/button/RadioBox";

// img
import delIcon from "../../../../assets/img/icon/delete.svg";
import addImg from "../../../../assets/img/icon/add_img.svg";
import addImg2 from "../../../../assets/img/picture/add_img2.jpg";

export default function MyInquiry({ setCompleteModal }) {
    //페이지 이동
    const navigate = useNavigate();
    const goBack = () => {
        navigate("/mypage/myinquiry");
    };

    const InquiryListData = [
        {
            id: "0",
            text: "취소문의",
        },
        {
            id: "1",
            text: "배송문의",
        },
        {
            id: "2",
            text: "교환문의",
        },
        {
            id: "3",
            text: "반품문의",
        },
        {
            id: "4",
            text: "오류문의",
        },
        {
            id: "5",
            text: "기타문의",
        },
        {
            id: "6",
            text: "AS문의",
        },
        {
            id: "7",
            text: "취소문의",
        },
    ];

    return (
        <Wrap>
            <TitleWrap>
                <Title>1:1문의</Title>
            </TitleWrap>
            <ContentWrap>
                <WhyOutText>문의사유</WhyOutText>
                <ReasonListWrap>
                    {InquiryListData.map((list, index) => {
                        return (
                            <ReasonList key={list.id}>
                                <RadioBox id={list.id} text={list.text} name="why" checked={index === 0 ? true : false} />
                            </ReasonList>
                        );
                    })}
                </ReasonListWrap>
                <Section>
                    <InputWrap>
                        <InputTitle>이름</InputTitle>
                        <InputText type="text" defaultValue="최신도" readOnly />
                    </InputWrap>
                    <InputWrap>
                        <InputTitle>이메일</InputTitle>
                        <InputText type="text" defaultValue="Sindoh1234@email.com" readOnly />
                    </InputWrap>
                </Section>
                <Section>
                    <InputWrap>
                        <InputTitle>제목</InputTitle>
                        <InputText type="text" placeholder="제목을 작성 해주세요" required />
                    </InputWrap>
                    <InputWrap>
                        <InputTitle textareaTitle>
                            문의
                            <MbBr />
                            내용
                        </InputTitle>
                        <TextArea placeholder="문의내용을 작성 해주세요" name="" required></TextArea>
                    </InputWrap>
                </Section>
                <Section>
                    <InputWrap>
                        <InputTitle WideWidth>사진첨부</InputTitle>
                        <AddImgBox>
                            <UploadImg>
                                <Img src={addImg2} alt="이미지" />
                                <DelIcon>
                                    <img src={delIcon} alt="삭제" />
                                </DelIcon>
                            </UploadImg>
                            <AddImgWrap>
                                <input type="file" id="input-file" />
                                <AddImg htmlFor="input-file"></AddImg>
                            </AddImgWrap>
                        </AddImgBox>
                    </InputWrap>
                    <InputWrap>
                        <PC>
                            <InputTitle></InputTitle>
                        </PC>
                        <InfoWrap>
                            <Info>상품 불량 및 오배송의 경우, 해당 제품 사진을 등록 부탁드립니다.</Info>
                            <Info>파일명은 영문만 가능하며, 파일당 최대 10MB 의 용량 제한이 있습니다.</Info>
                            <Info>가로사이즈가 450pixel을 초과하는 경우 자동으로 450픽셀로 조정됩니다.</Info>
                            <Info>첨부파일은 최대 2개까지 등록가능합니다.</Info>
                        </InfoWrap>
                    </InputWrap>
                </Section>
            </ContentWrap>

            <BtnWrap>
                <BasicBtn
                    onClick={() => {
                        goBack();
                    }}
                    gray={true}
                    text="취소"
                />
                <BasicBtn
                    onClick={() => {
                        setCompleteModal(true);
                    }}
                    text="등록하기"
                />
            </BtnWrap>
        </Wrap>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: 0 auto;
    }
`;

const TitleWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding-bottom: calc(100vw * (20 / 1920));
    margin-bottom: calc(100vw * (20 / 1920));
    border-bottom: 1px solid #000;

    @media screen and (max-width: 1300px) {
        padding-bottom: calc(100vw * (20 / 1300));
        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-bottom: ${M(20)};
        margin-bottom: ${M(20)};
    }
`;

const Title = styled.h3`
    font-size: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(25)};
    }
`;

const ContentWrap = styled.div`
    margin-bottom: calc(100vw * (60 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (60 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(50)};
    }
`;

const WhyOutText = styled.h4`
    font-size: calc(100vw * (20 / 1920));
    margin-bottom: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (20 / 1300));
        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
        margin-bottom: ${M(20)};
    }
`;

const ReasonListWrap = styled.ul`
    display: flex;
    flex-wrap: wrap;

    align-items: center;

    margin-bottom: calc(100vw * (28 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (28 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(30)};
    }
`;

const ReasonList = styled.li`
    flex-shrink: 0;
    width: 25%;

    &:nth-child(n + 5) {
        margin-top: calc(100vw * (24 / 1920));
    }

    @media screen and (max-width: 1300px) {
        &:nth-child(n + 5) {
            margin-top: calc(100vw * (24 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        &:nth-child(n + 5) {
            margin-top: ${M(25)};
        }
    }
`;
const TextArea = styled.textarea`
    width: 100%;
    height: calc(100vw * (250 / 1920));
    font-size: calc(100vw * (15 / 1920));
    padding: calc(100vw * (20 / 1920));

    border-radius: 4px;

    background: #fafafa;

    @media screen and (max-width: 1300px) {
        height: calc(100vw * (250 / 1300));
        font-size: calc(100vw * (15 / 1300));
        padding: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        height: ${M(250)};
        font-size: ${M(14)};
        padding: ${M(15)};
    }

    ${({ active }) => {
        return active
            ? `
            border: 1px solid var(--main-color);
            color: #222;
            background: #fff;
            `
            : `border: 1px solid #FAFAFA;`;
    }}
`;

const BtnWrap = styled.div`
    display: flex;
    justify-content: center;

    & > p {
        width: calc(100vw * (200 / 1920));
    }

    & > p:first-child {
        margin-right: calc(100vw * (19 / 1920));
    }

    @media screen and (max-width: 1300px) {
        & > p {
            width: calc(100vw * (200 / 1300));
        }

        & > p:first-child {
            margin-right: calc(100vw * (19 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        & > p {
            width: ${M(180)};
        }

        & > p:first-child {
            margin-right: ${M(15)};
        }
    }
`;

const Section = styled.div`
    padding: calc(100vw * (30 / 1920)) 0;

    border-bottom: 1px solid #eeeeee;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (30 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        padding: ${M(30)} 0;
        border-top: 1px solid #eeeeee;
    }
`;

const InputWrap = styled.div`
    display: flex;

    &:nth-child(2) {
        margin-top: calc(100vw * (20 / 1920));
    }

    @media screen and (max-width: 1300px) {
        &:nth-child(2) {
            margin-top: calc(100vw * (20 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        &:nth-child(2) {
            margin-top: ${M(20)};
        }
    }
`;

const InputTitle = styled.p`
    flex-shrink: 0;
    width: calc(100vw * (110 / 1920));

    font-size: calc(100vw * (15 / 1920));
    line-height: calc(100vw * (45 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (110 / 1300));

        font-size: calc(100vw * (15 / 1300));
        line-height: calc(100vw * (45 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(60)};

        font-size: ${M(14)};
        line-height: ${M(45)};

        ${({ textareaTitle }) => {
            return (
                textareaTitle &&
                `
                    line-height: 1.4;
                `
            );
        }}
        ${({ WideWidth }) => {
            return (
                WideWidth &&
                `
                    width: ${M(103)};
                    line-height: 1.3;
                `
            );
        }}
    }
`;

const InputText = styled.input`
    flex: 1;
    padding: calc(100vw * (11 / 1920)) calc(100vw * (23 / 1920));
    background: #fafafa;
    font-size: calc(100vw * (15 / 1920));

    border-radius: 4px;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (11 / 1300)) calc(100vw * (23 / 1300));
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding: ${M(12)} ${M(15)};
        font-size: ${M(14)};
    }
`;

const AddImgBox = styled.ul`
    display: flex;
    align-items: center;

    margin-top: calc(100vw * (20 / 1920));
    overflow-x: auto;

    & input {
        display: none;
    }

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: 0;
    }
`;
const UploadImg = styled.li`
    position: relative;

    flex-shrink: 0;
    width: calc(100vw * (100 / 1920));
    height: calc(100vw * (100 / 1920));

    overflow: hidden;

    &:not(:first-child) {
        margin-left: calc(100vw * (18 / 1920));
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (100 / 1300));
        height: calc(100vw * (100 / 1300));

        &:not(:first-child) {
            margin-left: calc(100vw * (18 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: ${M(100)};
        height: ${M(100)};

        &:not(:first-child) {
            margin-left: ${M(20)};
        }
    }
`;

const AddImg = styled.label`
    display: inline-block;
    width: 100%;
    height: 100%;

    background: url(${addImg}) no-repeat center center / contain;

    cursor: pointer;
`;

const Img = styled.img`
    width: 100%;
    height: 100%;
`;
const AddImgWrap = styled(UploadImg)``;

const DelIcon = styled.div`
    position: absolute;
    top: calc(100vw * (4 / 1920));
    right: calc(100vw * (4 / 1920));

    width: calc(100vw * (22 / 1920));
    height: calc(100vw * (22 / 1920));

    cursor: pointer;

    & img {
        display: block;
        width: 100%;
        height: 100%;
    }

    @media screen and (max-width: 1300px) {
        top: calc(100vw * (4 / 1300));
        right: calc(100vw * (4 / 1300));

        width: calc(100vw * (22 / 1300));
        height: calc(100vw * (22 / 1300));
    }

    @media screen and (max-width: 900px) {
        top: ${M(4)};
        right: ${M(4)};

        width: ${M(22)};
        height: ${M(22)};
    }
`;

const InfoWrap = styled.ul``;
const Info = styled.li`
    position: relative;

    font-size: calc(100vw * (14 / 1920));
    padding-left: calc(100vw * (10 / 1920));

    &:not(:first-child) {
        margin-top: calc(100vw * (10 / 1920));
    }

    &:after {
        position: absolute;
        top: 50%;
        left: 0;
        content: "";

        width: calc(100vw * (5 / 1920));
        height: 1px;
        background: var(--main-color);
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
        padding-left: calc(100vw * (10 / 1300));

        &:not(:first-child) {
            margin-top: calc(100vw * (10 / 1300));
        }

        &:after {
            width: calc(100vw * (5 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
        padding-left: ${M(10)};

        &:not(:first-child) {
            margin-top: ${M(5)};
        }

        &:after {
            top: ${M(9)};
            width: ${M(5)};
        }
    }
`;

const MbBr = styled.br`
    display: none;

    @media screen and (max-width: 900px) {
        display: block;
    }
`;
